import type { Id, Link } from "../api/types.gen.ts";

/** A link's values for its ref field's link fields (e.g. `{ bottles: 600 }`). */
export type LinkValues = Record<string, unknown>;

/** The item a link points at. */
export const linkId = (l: Link): Id => (typeof l === "string" ? l : l.id);

/** A link's values; none for a bare id. */
export function linkValues(l: Link): LinkValues {
  if (typeof l === "string") {
    return {};
  }
  const { id: _, ...values } = l;
  return values;
}

/** A link as the server stores it: the bare id when it carries no values. */
export function makeLink(id: Id, values: LinkValues): Link {
  const kept = Object.entries(values).filter(([, v]) => v !== undefined && v !== null);
  return kept.length > 0 ? { id, ...Object.fromEntries(kept) } : id;
}

/** `links` narrowed and reordered to `ids`, each remaining link keeping its values. */
export const withIds = (links: readonly Link[], ids: readonly Id[]): Link[] =>
  ids.map((id) => links.find((l) => linkId(l) === id) ?? id);
